import { z } from "zod";
import { fileSchema, phoneNumberSchema } from "@/lib/utils";

export const branchFormSchema = z.object({
	name: z.string().min(1),
	address: z.string(),
	email: z.union([z.email(), z.literal("")]),
	image: fileSchema().optional(),
	phoneNumber: z.union([phoneNumberSchema(), z.literal("")]),
});

export type BranchFormValues = z.infer<typeof branchFormSchema>;
